import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';
import styles from './FJPhotoRemoveBgDownload.module.less';
import PropTypes from 'prop-types';
import FJDropDown from '../../../../common/components/FJDropDown/FJDropDown';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis';
import FJImage from '../../../../common/components/FJImage/FJImage';
import classNames from 'classnames';
import { useMemo } from 'react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJEvent from '../../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant';

const FJPhotoRemoveBgDownload = ({
    isShowDropdown,
    isShow,
    downloadList,

    handleAllClick,
    handleItemClick,
    handleDownloadClick,
}) => {
    const isAllSelected = useMemo(() => {
        return downloadList.every(item => item.isSelected);
    }, [downloadList]);

    const _onDownloadClick = () => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        if (!isShowDropdown) {
            handleDownloadClick && handleDownloadClick();
        }
    };

    return (
        isShow && (
            <div className={styles.download_box}>
                {isShowDropdown ? (
                    <FJDropDown
                        triggerClick={_onDownloadClick}
                        overlay={
                            <div className={styles.download_dropdown}>
                                <div className={styles.download_dropdown_title}>{FJLocalStore._('select-images')}</div>

                                <div className={styles.download_dropdown_list_box}>
                                    <div className={styles.download_dropdown_all_select}>
                                        {FJLocalStore._('all-select').replace('xxx', downloadList.length)}
                                        <FJCheckBox
                                            className={styles.apply_to_all_checkbox}
                                            iconClassName={classNames(styles.apply_to_all_icon, {
                                                [styles.apply_to_all_icon_checked]: isAllSelected,
                                            })}
                                            selected={isAllSelected}
                                            dataChange={handleAllClick}
                                        />
                                    </div>
                                    <FJVerticalScroller className={styles.download_dropdown_list}>
                                        {downloadList.map(item => {
                                            return (
                                                <div
                                                    className={styles.download_dropdown_list_item}
                                                    key={item.id}
                                                    onClick={() => handleItemClick(item)}
                                                >
                                                    <FJImage
                                                        imgSrc={item.thumbnailUrl}
                                                        boxClassName={styles.download_dropdown_list_item_img}
                                                    />
                                                    <FJTextWithEllipsis
                                                        className={styles.download_dropdown_list_item_text}
                                                        text={item.name}
                                                    />

                                                    <FJCheckBox
                                                        className={styles.apply_to_all_checkbox}
                                                        iconClassName={classNames(styles.apply_to_all_icon, {
                                                            [styles.apply_to_all_icon_checked]: item.isSelected,
                                                        })}
                                                        selected={item.isSelected}
                                                        onChange={() => handleItemClick(item)}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </FJVerticalScroller>
                                </div>

                                <div className={styles.download_dropdown_footer}>
                                    <FJButton
                                        icon={<FJDownloadIcon className={styles.download_dropdown_footer_btn_icon} />}
                                        className={styles.download_dropdown_footer_btn}
                                        type={FJButtonType.GRADIENT}
                                        text='download'
                                        onClick={handleDownloadClick}
                                        textClassName={styles.download_btn_text}
                                    />
                                </div>
                            </div>
                        }
                    >
                        <FJButton
                            className={styles.download_btn}
                            type={FJButtonType.GRADIENT}
                            icon={<FJDownloadIcon className={styles.download_btn_icon} />}
                            text='download'
                            textClassName={styles.download_btn_text}
                        />
                    </FJDropDown>
                ) : (
                    <FJButton
                        className={styles.download_btn}
                        type={FJButtonType.GRADIENT}
                        icon={<FJDownloadIcon className={styles.download_btn_icon} />}
                        text='download'
                        onClick={_onDownloadClick}
                        textClassName={styles.download_btn_text}
                    />
                )}
            </div>
        )
    );
};

FJPhotoRemoveBgDownload.propTypes = {
    isShowDropdown: PropTypes.bool,
    isShow: PropTypes.bool,
    downloadList: PropTypes.array,
    handleAllClick: PropTypes.func,
    handleItemClick: PropTypes.func,
    handleDownloadClick: PropTypes.func,
};

export default FJPhotoRemoveBgDownload;
